<template>
  <div>
    <b-card>
      <b-col>
        <h5 class="section-title orange-color">
          Integrations
          <br />
          <small class="dark-blue-color">
            Manage your shop's integrations with 3rd party providers
          </small>
        </h5>
      </b-col>
    </b-card>
    <div class="w-75 mx-auto mt-5">
      <b-row>
        <b-col sm="12"
               md="6"
               lg="3">
          <b-card>
            <svg id="Your_design" data-name="Your design" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 306"><path d="M44.39,203.69V188.63h43A55.64,55.64,0,0,0,106,185.87a33.3,33.3,0,0,0,12.67-7.67A31.32,31.32,0,0,0,126,166.83a39.34,39.34,0,0,0,2.4-13.83,38.24,38.24,0,0,0-2.4-13.61A32.09,32.09,0,0,0,118.68,128,33.55,33.55,0,0,0,106,120.2a54.54,54.54,0,0,0-18.61-2.83H51.92a15.09,15.09,0,0,1-15.06-15.05H88.13a68.72,68.72,0,0,1,24.54,4.06,51.62,51.62,0,0,1,17.89,11.08,46,46,0,0,1,10.86,16.14A52.27,52.27,0,0,1,145,153a53.14,53.14,0,0,1-3.62,19.62,45.16,45.16,0,0,1-10.86,16.15,51.48,51.48,0,0,1-17.89,10.93,69.66,69.66,0,0,1-24.54,4Z"></path><polygon points="337.76 181.5 337.76 102.31 353.4 102.31 353.4 203.69 337.61 203.69 259.41 126.74 259.41 203.69 243.77 203.69 243.77 102.31 259.27 102.31 337.76 181.5"></polygon><path d="M556.79,117.37V102.31H452.13a15.1,15.1,0,0,0,15.06,15.06h89.6ZM452.13,188.63H556.79v15.06h-89.6a15.1,15.1,0,0,1-15.06-15.06Zm0-44.46H556.79v15.06h-89.6a15.1,15.1,0,0,1-15.06-15.06Z"></path><path d="M655.53,203.69V151.26h66.85a21.68,21.68,0,0,0,10.21-2.46,20.66,20.66,0,0,0,7.54-6.52,15.13,15.13,0,0,0,2.82-8.83,12.87,12.87,0,0,0-2.82-8.11,20,20,0,0,0-7.54-5.79,24.2,24.2,0,0,0-10.21-2.18h-51.8a15.09,15.09,0,0,1-15.05-15.05h71.2a33.42,33.42,0,0,1,16.44,4.13,32.5,32.5,0,0,1,11.94,11.22,28.9,28.9,0,0,1,4.49,15.79A29.46,29.46,0,0,1,754.68,150a36.64,36.64,0,0,1-18.86,14.41l29.72,39.39L746,203.69l-28.14-37.37H671.17v37.37Z"></path><path d="M901.88,205.13a72.66,72.66,0,0,1-24.62-4A59.93,59.93,0,0,1,857.86,190a50.59,50.59,0,0,1-12.75-16.65,48.36,48.36,0,0,1,0-40.7A50.59,50.59,0,0,1,857.86,116a59.93,59.93,0,0,1,19.4-11.15,77.71,77.71,0,0,1,49.1,0A59.93,59.93,0,0,1,945.76,116a51.49,51.49,0,0,1,12.82,16.65,47.69,47.69,0,0,1,0,40.7A51.49,51.49,0,0,1,945.76,190a59.93,59.93,0,0,1-19.4,11.15A72.25,72.25,0,0,1,901.88,205.13Zm0-15.2a56.21,56.21,0,0,0,18.25-2.82,45.87,45.87,0,0,0,14.34-7.83,35.41,35.41,0,0,0,9.41-11.73,33.45,33.45,0,0,0,0-29.1,35.41,35.41,0,0,0-9.41-11.73,45.67,45.67,0,0,0-14.34-7.83,56.21,56.21,0,0,0-18.25-2.82,56.82,56.82,0,0,0-18.32,2.82,45.49,45.49,0,0,0-14.41,7.83,34.57,34.57,0,0,0-9.34,11.73,34.1,34.1,0,0,0,0,29.1,34.57,34.57,0,0,0,9.34,11.73,45.69,45.69,0,0,0,14.41,7.83A56.82,56.82,0,0,0,901.88,189.93Z"></path></svg>
            <b-button class="w-100" variant="primary" v-b-modal.dnero-modal @click="selectedIntegration = 'dnero'">Edit</b-button>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal id="dnero-modal" hide-footer title="Dnero Integration">
      <form @submit.prevent="onDneroSave">
        <label>
          <input type="checkbox" class="mr-2" v-model="enabled"/>Enable Integration
        </label>
        <b-form-group label="API KEY">
          <b-input v-model="apiKey" placeholder="89733-92735287-8927343"/>
        </b-form-group>
        <b-button type="submit" class="w-100" variant="primary">
          Save
        </b-button>
      </form>
    </b-modal>
</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "integrations",
  data: () => ({
    integrations: [],
    selectedIntegration: null,
    apiKey: '',
    enabled: false
  }),
  computed: {
    ...mapGetters('shop', ['shop'])
  },
  async mounted() {
    if (this.shop) {
      this.integrations = this.shop.integrations;
    }
  },
  methods: {
    async onDneroSave() {
      let integrationIndex = this.integrations.findIndex(i => i.type === this.selectedIntegration);
      if (integrationIndex > -1) this.integrations[integrationIndex] = {enabled: this.enabled, apiKey: this.apiKey, type: this.selectedIntegration};
      else this.integrations.push({enabled: this.enabled, type: this.selectedIntegration, apiKey: this.apiKey});

      await this.$store.dispatch('shop/UPDATE_SHOP', {shopInfo: {integrations: this.integrations}, shopId: this.shop._id})
    }
  },
  watch: {
    shop(newVal) {
      if (newVal && newVal.integrations) this.integrations = newVal.integrations;
    },
    selectedIntegration(newVal) {
      if (newVal) {
        let integration = this.integrations.find(i => i.type === newVal);
        this.apiKey = !integration ? '' : integration.apiKey;
        this.enabled = !integration ? false : integration.enabled;
      }
    }
  }
}
</script>

<style scoped>

</style>
